import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'
import { CRM_PIPELINE_API } from '../api/crm-pipeline-api'
import { CrmPipelineApiInterface } from '../types/pipeline-interface'

interface CrmPipelineListProps extends SwrPaginationInterface {}

export function useCrmPipelineList({ pagination, limit }: CrmPipelineListProps) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CrmPipelineApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: crmPipelineList, mutate } = useSWR(() => {
    if (user) {
      return `${CRM_PIPELINE_API}?${getPaginationQueryString({
        limit,
        pagination,
      })}`
    }
    return null
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${CRM_PIPELINE_API}/count?${getPaginationQueryString({
        limit,
        pagination,
      })}`
    }
    return null
  }, baseFetcher)

  return { crmPipelineList, mutate, counter }
}
